import { generateUtilityClasses } from '@mui/material';

export const tableClasses = generateUtilityClasses('Table', ['root']);
